import { supabase } from '../lib/supabase';

export const reviewService = {
  // Get all reviews
  async getReviews() {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .eq('published', true)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  // Get all reviews for admin
  async getAllReviews() {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  // Create new review
  async createReview(reviewData) {
    const { data, error } = await supabase
      .from('reviews')
      .insert([reviewData])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Update review
  async updateReview(id, reviewData) {
    const { data, error } = await supabase
      .from('reviews')
      .update(reviewData)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Delete review
  async deleteReview(id) {
    const { error } = await supabase
      .from('reviews')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  // Update helpful count
  async updateHelpfulCount(id, helpfulCount) {
    const { data, error } = await supabase
      .from('reviews')
      .update({ helpful: helpfulCount })
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  }
}; 